import { Link } from "react-router-dom";

export const Footer = ({ onNavigate }) => {
  const go = (href) => (e) => {
    e.preventDefault();
    onNavigate?.(href);
  };

  const NAV_LINKS = [
    { label: "Services", href: "#services" },
    { label: "Cases", href: "#cases" },
    { label: "Priser", href: "#priser" },
    { label: "Om os", href: "#om-os" },
  ];

  return (
    <footer className="border-t border-zinc-200/80 bg-white py-14" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid gap-10 md:grid-cols-3">
          <div>
            <a
              href="#hjem"
              onClick={go("#hjem")}
              data-testid="footer-logo"
              className="flex items-center gap-2.5 font-bold text-lg tracking-tight text-zinc-900"
            >
              <span className="w-3.5 h-3.5 bg-zinc-900 rounded-[4px]" aria-hidden="true" />
              Naveli
            </a>
            <p className="mt-4 text-sm text-zinc-500 leading-relaxed max-w-xs">
              Professionelle hjemmesider til danske virksomheder.
            </p>
          </div>

          <div>
            <h3 className="text-xs font-semibold uppercase tracking-[0.2em] text-zinc-500 mb-4">
              Kontakt
            </h3>
            <ul className="space-y-2.5 text-sm text-zinc-600">
              <li>
                <a
                  href="mailto:naveli.dk@gmail.com"
                  data-testid="footer-email-link"
                  className="hover:text-zinc-900 transition-colors duration-200"
                >
                  naveli.dk@gmail.com
                </a>
              </li>
              <li>
                <a
                  href="tel:+4522664605"
                  data-testid="footer-phone-link"
                  className="hover:text-zinc-900 transition-colors duration-200"
                >
                  22 66 46 05
                </a>
              </li>
              <li>
                <a
                  href="tel:+4542173209"
                  data-testid="footer-phone-2-link"
                  className="hover:text-zinc-900 transition-colors duration-200"
                >
                  42 17 32 09
                </a>
              </li>
            </ul>
            <h3 className="text-xs font-semibold uppercase tracking-[0.2em] text-zinc-500 mt-8 mb-4">
              Juridisk
            </h3>
            <ul className="space-y-2.5 text-sm text-zinc-600">
              <li>
                <Link
                  to="/privatlivspolitik"
                  data-testid="footer-privacy-link"
                  className="hover:text-zinc-900 transition-colors duration-200"
                >
                  Privatlivspolitik
                </Link>
              </li>
              <li>
                <Link
                  to="/cookiepolitik"
                  data-testid="footer-cookie-link"
                  className="hover:text-zinc-900 transition-colors duration-200"
                >
                  Cookiepolitik
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-xs font-semibold uppercase tracking-[0.2em] text-zinc-500 mb-4">
              Genveje
            </h3>
            <ul className="space-y-2.5 text-sm text-zinc-600">
              {NAV_LINKS.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    onClick={go(link.href)}
                    data-testid={`footer-link-${link.href.replace("#", "")}`}
                    className="hover:text-zinc-900 transition-colors duration-200"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-zinc-100 flex flex-col sm:flex-row justify-between gap-3">
          <p className="text-xs text-zinc-400">
            © 2026 Naveli. Alle rettigheder forbeholdes.
          </p>
          <p className="text-xs text-zinc-400">Designet og bygget i Danmark</p>
        </div>
      </div>
    </footer>
  );
};
